import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPostcardIcon from './svgs/PostcardIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var postcardIcon = (props => useIcon(SvgPostcardIcon, SvgPostcardIcon, props));

export { postcardIcon as default };
